var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timestamp)?_c('div',{staticClass:"badge last-seen",class:_vm.colorByDays},[(!_vm.noText)?_c('span',[_vm._v(_vm._s(_vm._f("humanizeSeconds")(_vm.diff)))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }